import { api } from "@/api/client";

export default function Login() {
  const onLogin = () => {
    window.location.href = api.loginUrl(window.location.pathname + window.location.search);
  };
  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 px-6 text-center">
      <img
        src="/icon-512.png"
        alt="ISAC"
        className="h-24 w-24 rounded-2xl"
      />
      <div>
        <h1 className="text-xl font-bold">ISAC 지식 Q&A</h1>
        <p className="mt-1 text-sm text-muted-foreground">인성정보 지식 저장소에 무엇이든 물어보세요.</p>
      </div>
      <button
        onClick={onLogin}
        className="w-full max-w-xs rounded-lg bg-[#EB4E26] px-4 py-3 font-semibold text-white active:opacity-90"
      >
        네이버웍스로 로그인
      </button>
      <p className="text-xs text-muted-foreground">사내 계정으로만 이용할 수 있습니다.</p>
    </div>
  );
}
